import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'usb-request-header',
  templateUrl: './request-header.component.html',
  styleUrls: ['./request-header.component.scss']
})
export class UsbRequestHeaderComponent {
  @Input() formGroup: FormGroup;
  @Input() selectedFile: any;
  @Input() selectedClient: any;
  @Input() availablePax: any[];
  @Input() loadingFiles: boolean;
  @Input() loadingPax: boolean;
  @Input() showNewFileNameInput: boolean;
  @Input() showNewClientInput: boolean;
  @Input() existingFiles: any[];
  @Input() countriesData: any[];
  @Input() loadingCountries: boolean;
  @Input() newFilePassenger: string;
  @Input() newFilePassengerError: boolean;
  @Input() newFilePhoneCode: string;
  @Input() newFilePhoneCodeError: boolean;
  @Input() newFilePhone: string;
  @Input() newFilePhoneError: boolean;
  @Input() newFileEmail: string;
  @Input() newFileEmailError: boolean;
  @Input() phoneCodeSelected: string;
  @Input() selectedFileId: string;
  @Input() selectedClientId: string;
  @Input() phoneCodeError: boolean;
  @Input() firstNameError: boolean;
  @Input() lastNameError: boolean;
  @Input() emailError: boolean;
  @Input() requiredFieldMessage: (tab: string, field: string) => string;
  @Input() getFileLabel: (f: any) => string;
  @Input() getClientLabel: (c: any) => string;
  @Input() getClientsForSelectedFile: () => any[];
  @Input() isNuevoFileValid: () => boolean;
  @Input() blockInvalidKeys: (event: KeyboardEvent, type: string) => void;
  @Input() displayCountryFn: (value: any) => string;
  @Input() edit: boolean = false;

  @Output() fileChange = new EventEmitter<any>();
  @Output() clientChange = new EventEmitter<any>();
  @Output() paxChange = new EventEmitter<any>();
  @Output() requestTypeChange = new EventEmitter<'quotation' | 'reservation' | 'on_hold'>();
  @Output() newFileToggle = new EventEmitter<void>();
  @Output() newClientToggle = new EventEmitter<void>();
  @Output() newFileSubmit = new EventEmitter<void>();
  @Output() newClientSubmit = new EventEmitter<{
    first_name: string;
    last_name: string;
    email: string;
    phone_code: string;
    phone: string;
  }>();
  @Output() fileSearchInput = new EventEmitter<string>();
  @Output() clearSelectedFile = new EventEmitter<void>();
  @Output() passengerIdChange = new EventEmitter<any>();
  @Output() passengerFirstNameChange = new EventEmitter<string>();
  @Output() passengerLastNameChange = new EventEmitter<string>();
  @Output() newFilePassengerInput = new EventEmitter<string>();
  @Output() newFilePhoneCodeInput = new EventEmitter<string>();
  @Output() newFileCountrySelected = new EventEmitter<any>();
  @Output() newFilePhoneInput = new EventEmitter<string>();
  @Output() newFileEmailInput = new EventEmitter<string>();
  @Output() countrySelected = new EventEmitter<any>();
  @Output() phoneCodeInput = new EventEmitter<string>();
  @Output() clientFirstNameChange = new EventEmitter<string>();
  @Output() clientLastNameChange = new EventEmitter<string>();
  @Output() clientEmailChange = new EventEmitter<string>();
  @Output() clientPhoneChange = new EventEmitter<string>();
}
